import {Action, handleActions} from "redux-actions";
import {
	TOS_ACCEPTED,
	USER_CREATED,
	USER_LOGIN_SUCCESSFUL,
	USER_LOGOUT,
	USER_SUSPEND_UPDATED,
	USER_UPDATED,
	USERS_FETCHED
} from "../../action/user/actionType";
import {UserState} from "./UserState";
import {none, option} from "ts-option";
import UserConsentData, {UserConsentType} from "../../../model/user/UserConsentData";

/**
 * Initial state for user.
 */
const initState: UserState = {
	user: none,
	initialized: false,
	users: none
};

const reducer = handleActions({
	[USER_LOGOUT]: (state: UserState, action: Action<USER_LOGOUT>): UserState => {
		return {...state, ...initState, initialized: true}
	},
	[USER_LOGIN_SUCCESSFUL]: (state: UserState, action: Action<USER_LOGIN_SUCCESSFUL>): UserState => {
		return {...state, user: option(action.payload.user), initialized: true}
	},
	[USERS_FETCHED]: (state: UserState, action: Action<USERS_FETCHED>): UserState => {
		return {...state, users: option(action.payload.users)}
	},
	[USER_CREATED]: (state: UserState, action: Action<USER_CREATED>): UserState => {
		return {...state, users: option(state.users.getOrElse([]).concat(action.payload.user))}
	},
	[USER_UPDATED]: (state: UserState, action: Action<USER_UPDATED>): UserState => {
		const user = state.user.map(u => {
			if (action.payload.user.id == state.user.get.id) {
				return u.copy({data: action.payload.user.data})
			}
			else {
				return u;
			}
		});
		const users = state.users.getOrElse([]).map(u => u.id == action.payload.user.id ? action.payload.user : u);
		return {...state, users: option(users), user}
	},
	[TOS_ACCEPTED]: (state: UserState): UserState => {
		const consents = state.user.get.consents.concat(new UserConsentData(UserConsentType.Crm));
		return {...state, user: state.user.map(u => u.copy({consents}))}
	},
	[USER_SUSPEND_UPDATED]: (state: UserState, action: Action<USER_SUSPEND_UPDATED>): UserState => {
		const users = state.users.getOrElse([]).map(
			u => u.id == action.payload.userId ? u.copy({disabled: action.payload.disabled}) : u);
		return {...state, users: option(users)}
	}
}, initState);

export default reducer;